/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Title"
  
}) {
let appNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'name',
})
let stepsStepsValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'steps',
})
let aggregateData = fromHelpers.getText(appNameValueData, stepsStepsValueData)
  return (<React.Fragment
>
<TysiaModalHeaderTitle
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 data="app.name"
 data="steps.steps"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}